import React, { MouseEventHandler } from 'react';
import { KebabCase } from '../../../utils/StringUtil';
import { onExecuteKeyDown } from '../../../utils/KeyboardUtil';

interface MenuItem {
  title: string;
  target_url: string;
  id?: string;
}

interface SidebarMenuItemProps {
  item: MenuItem;
  isSelected: any;
  navigate?: any;
  frontEndDomain?: string;
  onClickLink: (url: string) => void;
}

export const SidebarMenuItem: React.FC<SidebarMenuItemProps> = ({
  item,
  isSelected,
  navigate,
  frontEndDomain,
  onClickLink,
}) => {
  const isFrontEndDestination = item.target_url?.includes(frontEndDomain || '');
  const isFrontEnd =
    typeof window !== 'undefined' && window.location.href.includes(frontEndDomain || '') && isFrontEndDestination;

  const targetUrl: any = isFrontEnd ? null : item.target_url;

  const onClick: MouseEventHandler<HTMLAnchorElement> = e => {
    if (!isFrontEnd) return false;
    e.stopPropagation();
    e.preventDefault();
    onClickLink(item.target_url);
    if (navigate) {
      navigate(item.target_url.replace(frontEndDomain || '', ''));
    } else {
      window.location.href = item.target_url.replace(frontEndDomain || '', '');
    }
  };

  return (
    <li className={isSelected(item) ? 'selected' : ''}>
      <a
        aria-current={isSelected(item) ? 'page' : undefined}
        role="link"
        data-object-type="sidebar-navigation"
        data-object-action={`sidebar-${KebabCase(item.title)}-select`}
        id={item.id}
        href={targetUrl || item.target_url}
        onClick={onClick}
        onKeyDown={onExecuteKeyDown(onClick)}
        tabIndex={0}
      >
        {item.title}
      </a>
    </li>
  );
};

SidebarMenuItem.displayName = 'SidebarMenuItem';
